<template>
  <NxInput
    name="quadro"
    type="select"
    label="Quadro:"
    :option-groups="listOptions"
    placeholder="Selecione o Quadro"
    @update:value="handleValueUpdate"
  ></NxInput>
</template>
<script>
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'

import { JWTService } from '@/shared/services/jwt'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'NxSelectQuadro',
  mixins: [useReactiveModelMixin('value')],
  props: {
    onlyActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isAdmin: false,
      onlyShowActive: false,
      listOptions: {},
      selected: null
    }
  },
  created () {
    this.onlyShowActive = this.onlyActive
    this.checkIsAdmin()
    this.onLoadBoards()
  },
  methods: {
    onLoadBoards () {
      BoardRepository.Board_GetAll()
        .then((res) => {
          let activeOptions = this.filterAndReduce(res, (x) => !x.arquivado)
          let filedOptions = this.filterAndReduce(res, (x) => x.arquivado)

          let options = []

          if (this.onlyShowActive) {
            options = {
              Ativos: activeOptions
            }
          } else {
            options = {
              Ativos: activeOptions,
              Arquivados: filedOptions
            }
          }

          this.listOptions = options
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Quadros', 'Erro')
          console.error(err)
        })
    },
    filterAndReduce (res, condition) {
      return res.data.content
        .filter((x) => x.id != null && condition(x))
        .reduce((acc, x) => {
          acc[x.id] = x.nome
          return acc
        }, {})
    },
    checkIsAdmin () {
      this.isAdmin = JWTService.GetRoles().some(
        (role) => role === Roles.ADMINISTRADOR
      )
      if (!this.isAdmin) this.onlyShowActive = true
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectQuadro.vue